import { FormProvider } from '../store';

import FormLayout from './Form';

export default function FieldFormLayout() {
  return <FormProvider>
    <FormLayout builder />
  </FormProvider>
}
